module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/spec-offer-9450303614b883765c9e303a57564c23.png";